import React from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import CameraIcon from '@mui/icons-material/Camera';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WifiIcon from '@mui/icons-material/Wifi';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SecurityIcon from '@mui/icons-material/Security';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

function Copyright(props) {
    return (
        <Typography variant="body2" color="darkslategray" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="https://diskominfo.makassarkota.go.id/">
                Diskominfo Kota Makassar
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const defaultTheme = createTheme({
    palette: {
        primary: {
            main: '#1dc39f',
        },
        secondary: {
            main: '#8ff9ab',
        },
    },
    typography: {
        h4: {
            fontWeight: 600,
        },
        h6: {
            fontWeight: 600,
        },
    },
});


const HalPilihLayanan = () => {
    const navigate = useNavigate();

    const services = [
        // {
        //     title: 'Cek Longwis 244',
        //     description: 'Monitoring dan pengecekan CCTV Longwis area 244',
        //     icon: <CameraIcon sx={{ fontSize: 40 }} />,
        //     route: '/pic/longwis',
        //     color: '#1dc39f'
        // },
        // {
        //     title: 'Laporan Longwis 1815',
        //     description: 'Laporan dan data lokasi Longwis area 1815',
        //     icon: <LocationOnIcon sx={{ fontSize: 40 }} />,
        //     route: '/pic/longwis-lokasi',
        //     color: '#2196f3'
        // },
        {
            title: 'Internet Longwis',
            description: 'Status dan monitoring koneksi internet Longwis',
            icon: <WifiIcon sx={{ fontSize: 40 }} />,
            route: '/pic/internetlongwis',
            color: '#ff9800'
        },
        {
            title: 'Monitoring CCTV',
            description: 'Pantau live streaming dan status CCTV Longwis',
            icon: <SecurityIcon sx={{ fontSize: 40 }} />,
            route: '/pic/daftar-longwis-monitoring-cctv',
            color: '#e91e63'
        },
        {
            title: 'Keluhan Longwis',
            description: 'Buat dan pantau keluhan dari lokasi Longwis',
            icon: <ReportProblemIcon sx={{ fontSize: 40 }} />,
            route: '/pic/daftar-longwis-keluhan',
            color: '#ff5722'
        }
    ];

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #1dc39f 0%, #8ff9ab 100%)',
                py: 3
            }}
        >
            <ThemeProvider theme={defaultTheme}>
                <Container component="main" maxWidth="lg">
                    <CssBaseline />
                    <Paper
                        elevation={10}
                        sx={{
                            p: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            borderRadius: 3,
                            background: 'rgba(255, 255, 255, 0.95)',
                            backdropFilter: 'blur(10px)',
                        }}
                    >
                        {/* Header */}
                        <Box
                            sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                backgroundColor: 'primary.main',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mb: 2,
                                boxShadow: 3
                            }}
                        >
                            <DashboardIcon sx={{ fontSize: 40, color: 'white' }} />
                        </Box>
                        
                        <Typography component="h1" variant="h4" sx={{ mb: 1, color: 'primary.main' }}>
                            Pilih Layanan
                        </Typography>
                        
                        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary', textAlign: 'center' }}>
                            Silakan pilih layanan yang ingin Anda akses
                        </Typography>

                        {/* Services Grid */}
                        <Grid container spacing={3} sx={{ width: '100%', maxWidth: 1000 }}>
                            {services.map((service, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <Card
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                            border: '1px solid',
                                            borderColor: 'grey.200',
                                            '&:hover': {
                                                transform: 'translateY(-4px)',
                                                boxShadow: 6,
                                                borderColor: service.color,
                                            }
                                        }}
                                        onClick={() => navigate(service.route)}
                                    >
                                        <CardContent sx={{ flexGrow: 1, textAlign: 'center', pt: 3 }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    mb: 2,
                                                    color: service.color,
                                                    transition: 'transform 0.3s ease',
                                                    '&:hover': {
                                                        transform: 'scale(1.1)'
                                                    }
                                                }}
                                            >
                                                {service.icon}
                                            </Box>
                                            <Typography 
                                                variant="h6" 
                                                component="h2" 
                                                sx={{ 
                                                    mb: 1,
                                                    fontSize: { xs: '1rem', sm: '1.25rem' },
                                                    fontWeight: 600
                                                }}
                                            >
                                                {service.title}
                                            </Typography>
                                            <Typography 
                                                variant="body2" 
                                                color="text.secondary"
                                                sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                                            >
                                                {service.description}
                                            </Typography>
                                        </CardContent>
                                        <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    background: `linear-gradient(45deg, ${service.color} 30%, ${service.color}cc 90%)`,
                                                    textTransform: 'none',
                                                    fontWeight: 600,
                                                    px: 3,
                                                    borderRadius: 2,
                                                    '&:hover': {
                                                        background: `linear-gradient(45deg, ${service.color}dd 30%, ${service.color}aa 90%)`,
                                                        transform: 'scale(1.05)'
                                                    }
                                                }}
                                            >
                                                Akses
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        {/* Additional Information */}
                        <Box sx={{ mt: 4, textAlign: 'center' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Semua layanan terintegrasi dalam sistem monitoring Longwis Kota Makassar
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => navigate('/')}
                                    sx={{ 
                                        textTransform: 'none',
                                        borderColor: 'primary.main',
                                        color: 'primary.main',
                                        '&:hover': {
                                            backgroundColor: 'primary.main',
                                            color: 'white'
                                        }
                                    }}
                                >
                                    Kembali ke Home
                                </Button>
                            </Box>
                        </Box>

                        <Copyright sx={{ mt: 4 }} />
                    </Paper>
                </Container>
            </ThemeProvider>
        </Box>
    );
}

export default HalPilihLayanan;